<template>
    <div class="main">
        <c-panel>
            <!-- Gera o TXT no layout de importação de eventuais do SIP (Fiorilli) -->
            <el-form label-position="top" class="u-mb-10">
                <el-row :gutter="10">
                    <el-col :xs="12" :sm="5" :md="4">
                        <el-form-item label="Mês">
                            <el-select v-model="filtro.mes" style="width: 100%;">
                                <el-option v-for="m in meses" :key="m.value" :label="m.label" :value="m.value"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="12" :sm="5" :md="4">
                        <el-form-item label="Ano">
                            <el-input-number v-model="filtro.ano" :min="2000" :max="2100" :controls="false" style="width: 100%;"></el-input-number>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="14" :md="12">
                        <el-form-item label="Instituição (opcional)">
                            <el-select v-model="filtro.instituicao_cod" filterable clearable placeholder="Todas as instituições" style="width: 100%;">
                                <el-option v-for="i in instituicoes" :key="i.codigo" :label="i.nome" :value="i.codigo"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="4">
                        <el-button @click="gerarPrevia" type="info" plain icon="el-icon-search" style="width: 100%; margin-top: 21px;">GERAR</el-button>
                    </el-col>
                </el-row>
            </el-form>

            <div v-if="previa">
                <!-- O arquivo leva apenas faltas e os eventos da aba Folha; licenças e
                     férias são registro interno e não entram na exportação. -->
                <el-alert v-if="previa.total" type="success" :closable="false" class="u-mb-10"
                    :title="`${previa.total} linha(s) — faltas: ${previa.resumo.faltas}, folha: ${previa.resumo.eventos}`">
                    <div style="margin-top: 4px;">{{ periodo }}</div>
                </el-alert>
                <el-alert v-else type="warning" :closable="false" class="u-mb-10"
                    title="Nenhum lançamento a exportar nesta competência.">
                    <div style="margin-top: 4px;">{{ periodo }}</div>
                </el-alert>

                <el-alert v-if="previa.nao_exportados && previa.nao_exportados.length" type="warning" :closable="false" class="u-mb-10"
                    :title="`${previa.nao_exportados.length} lançamento(s) precisam de atenção`">
                    <ul style="margin: 5px 0 0 15px;">
                        <li v-for="(n, i) in previa.nao_exportados" :key="i">{{ n.servidor }}: {{ n.motivo }}</li>
                    </ul>
                </el-alert>

                <div class="u-text-right u-mb-10" v-if="previa.total">
                    <el-button type="primary" icon="el-icon-download" @click="baixar">BAIXAR ARQUIVO ({{ previa.nome_arquivo }})</el-button>
                </div>

                <div class="container-table" v-if="previa.total">
                    <pre style="background: #f5f7fa; padding: 12px; overflow-x: auto; font-family: monospace; font-size: 12px;">{{ previa.linhas.join('\n') }}</pre>
                </div>
            </div>
        </c-panel>
    </div>
</template>

<script>
export default {
    data: () => ({
        instituicoes: [],
        previa: null,
        filtro: { mes: new Date().getMonth() + 1, ano: new Date().getFullYear(), instituicao_cod: '' },
        meses: [
            { value: 1, label: 'Janeiro' }, { value: 2, label: 'Fevereiro' }, { value: 3, label: 'Março' },
            { value: 4, label: 'Abril' }, { value: 5, label: 'Maio' }, { value: 6, label: 'Junho' },
            { value: 7, label: 'Julho' }, { value: 8, label: 'Agosto' }, { value: 9, label: 'Setembro' },
            { value: 10, label: 'Outubro' }, { value: 11, label: 'Novembro' }, { value: 12, label: 'Dezembro' }
        ]
    }),
    computed: {
        // A janela da competência depende do dia de corte definido em Configurações,
        // então o intervalo real precisa ficar visível antes de gerar o arquivo.
        periodo () {
            const c = this.previa && this.previa.competencia
            if (!c) return ''
            return `Competência ${String(c.mes).padStart(2, '0')}/${c.ano} — lançamentos de `
                + `${this.formataData(c.data_inicial)} a ${this.formataData(c.data_final)}.`
        }
    },
    mounted () {
        this.getInstituicoes()
    },
    methods: {
        baseUrl () {
            return `${this.$store.state.config.baseUrlApi}/api/folha-ponto`
        },
        formataData (data) {
            if (!data) return '-'
            const d = String(data).substring(0, 10).split('-')
            return d.length === 3 ? `${d[2]}/${d[1]}/${d[0]}` : data
        },
        getInstituicoes () {
            this.$axios.get(`${this.baseUrl()}/instituicoes`, this.$store.getters.getHeaderAuth)
                .then(res => { this.instituicoes = (res.data && res.data.instituicoes) || [] })
                .catch(e => this.$store.commit('throwException', e))
        },
        gerarPrevia () {
            window.eventBus.$emit('loading', true)
            this.$axios.post(`${this.baseUrl()}/exportacao/previa`, this.filtro, this.$store.getters.getHeaderAuth)
                .then(res => { this.previa = res.data; window.eventBus.$emit('loading', false) })
                .catch(e => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', e) })
        },
        baixar () {
            window.eventBus.$emit('loading', true)
            this.$axios.post(`${this.baseUrl()}/exportacao/gerar`, this.filtro,
                Object.assign({ responseType: 'blob' }, this.$store.getters.getHeaderAuth))
                .then(res => {
                    const url = window.URL.createObjectURL(new Blob([res.data], { type: 'text/plain' }))
                    const link = document.createElement('a')
                    link.href = url
                    link.setAttribute('download', this.previa.nome_arquivo)
                    document.body.appendChild(link)
                    link.click()
                    document.body.removeChild(link)
                    window.URL.revokeObjectURL(url)
                    window.eventBus.$emit('loading', false)
                })
                .catch(e => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', e) })
        }
    }
}
</script>
